import { render, staticRenderFns } from "./MyHelpTask.vue?vue&type=template&id=633b954b&scoped=true&"
import script from "./MyHelpTask.vue?vue&type=script&lang=js&"
export * from "./MyHelpTask.vue?vue&type=script&lang=js&"
import style0 from "./MyHelpTask.vue?vue&type=style&index=0&id=633b954b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633b954b",
  null
  
)

export default component.exports